/* Copyright (c) 2018 Curo Digital
 * @file carousel-radio.js
 * @author F. Loreggian
 * Radio group for component for Carousel
 */

import React, { Component } from 'react';

export default class CarouselRadio extends Component {

  getRange() {
    return Array.from(Array(this.props.size).keys());
  }

  render() {
    return (
      <ul className="bullets">
        {this.getRange().map((i) => {
          return (
            <li
              className={this.props.index === i ? 'active' : ''}
              key={i}
              onClick={() => {
                this.props.selectSlide(i);
              }}
            >
              <span />
            </li>
          );
        })}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Carousel/carousel-radio.js